import type { AccumulatorsReportSchema } from '@libs/data-access/queries'
import { httpServices } from 'libs/data-access/queries/src/lib/apis'
import type { QueryFnParams } from 'libs/data-access/queries/src/lib/types'

import type { RestCounterType } from '../../types/RestCounter'

export type FetchAccumulatorsReportOptions = QueryFnParams<{
  pathParams: { type: RestCounterType }
  queryParams: {
    report_id?: number
    search?: string
    page?: number
    per_page?: number
  }
}>

/**
 *
 */
export const fetchAccumulatorsReport = async (
  opts: FetchAccumulatorsReportOptions
) => {
  const response = await httpServices.core.get<AccumulatorsReportSchema>(
    `/${opts.pathParams.type}/accumulators/report`,
    {
      params: opts?.queryParams
    }
  )
  return response.data
}
